// composables/useTheme.js
import { computed } from 'vue'
import { useTheme } from 'vuetify'

export function useThemeManager() {
  const theme = useTheme()
  
  const isDark = computed(() => theme.global.name.value === 'dark')

  const toggleTheme = () => {
    const newTheme = isDark.value ? 'light' : 'dark'
    theme.change(newTheme) // Используем новый метод change()
    localStorage.setItem('theme', newTheme)
  }

  const setTheme = (themeName) => {
    theme.change(themeName) // Используем новый метод change()
    localStorage.setItem('theme', themeName)
  }

  const initTheme = () => {
    const savedTheme = localStorage.getItem('theme')
    if (savedTheme) {
      setTheme(savedTheme)
    } else {
      // Системные предпочтения
      if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
        setTheme('dark')
      }
      // По умолчанию оставляем светлую тему (Vuetify по умолчанию использует light)
    }
  }

  return {
    isDark,
    toggleTheme,
    initTheme,
    setTheme
  }
}